module.exports = __webpack_public_path__ + "static/media/6.abd7c13f.png";